import React, { useRef, useEffect } from "react";

// ─── CONTEXT MENU ─────────────────────────────────────────────
const ContextMenu = ({ x, y, onClose, onSettings, onHLine, onTrendline, onClearDrawings, onResetZoom, onSetAlert }) => {
  const ref = useRef(null);
  useEffect(() => {
    const h = () => onClose();
    setTimeout(()=>document.addEventListener('click',h),0);
    return ()=>document.removeEventListener('click',h);
  }, []);

  const items = [
    { label:"Chart Settings…", icon:"⚙", action:onSettings },
    null,
    { label:"Add Horizontal Line", icon:"—", action:onHLine },
    { label:"Add Trendline", icon:"╱", action:onTrendline },
    { label:"Clear All Drawings", icon:"✕", action:onClearDrawings },
    null,
    { label:"Reset Zoom / Scroll", icon:"⊡", action:onResetZoom },
    null,
    { label:"Set Alert at Price", icon:"🔔", action:onSetAlert },
  ];

  return (
    <div ref={ref} style={{
      position:"fixed", left:x, top:y, zIndex:9000,
      background:"#1e1e1e", border:"1px solid rgba(255,255,255,0.12)",
      borderRadius:4, minWidth:200, boxShadow:"0 10px 36px rgba(0,0,0,0.8)",
      padding:"4px 0", fontFamily:"'IBM Plex Sans',sans-serif", fontSize:12,
    }} onClick={e=>e.stopPropagation()}>
      {items.map((item,i) => item===null ? (
        <div key={i} style={{ height:1, background:"rgba(255,255,255,0.07)", margin:"3px 0" }}/>
      ) : (
        <div key={i} onClick={()=>{ item.action(); onClose(); }} style={{
          display:"flex", alignItems:"center", gap:10, padding:"7px 14px", color:"#bbb", cursor:"pointer",
        }}
          onMouseEnter={e=>e.currentTarget.style.background="#2a2a2a"}
          onMouseLeave={e=>e.currentTarget.style.background="transparent"}
        >
          <span style={{ width:14, textAlign:"center", color:"#555", fontSize:13 }}>{item.icon}</span>
          {item.label}
        </div>
      ))}
    </div>
  );
};

export { ContextMenu };
